// ============================================
// 2. Watchlist.js - Complete Trading Watchlist
// ============================================

import React, { useState } from 'react';

const Watchlist = () => {
  const [watchlistItems, setWatchlistItems] = useState([
    {
      id: 1,
      ticker: 'AAPL',
      tradetype: 'Options Core',
      entryCatalyst: 'iPhone 16 Production Ramp + Services Growth',
      smartScore: 8.7,
      currentPrice: 189.45,
      entryTarget: 185.50,
      exitTarget: 205.00,
      stopLoss: 180.00,
      riskReward: 3.5,
      marketCap: '2.9T',
      volume: 28450000,
      lastUpdated: '2025-08-03 09:15:00',
      priority: 'High',
      notes: 'Waiting for pullback to 185 level. Strong earnings setup.',
      sector: 'Technology'
    },
    {
      id: 2,
      ticker: 'LMT',
      tradetype: 'Government Intel',
      entryCatalyst: 'Congressional Defense Spending Bill + F-35 Contract Extension',
      smartScore: 9.2,
      currentPrice: 422.10,
      entryTarget: 415.00,
      exitTarget: 460.00,
      stopLoss: 395.00,
      riskReward: 2.25,
      marketCap: '105B',
      volume: 1850000,
      lastUpdated: '2025-08-03 09:12:00',
      priority: 'High',
      notes: 'Perfect government intel setup. High conviction trade.',
      sector: 'Defense'
    },
    {
      id: 3,
      ticker: 'NVDA',
      tradetype: 'Phoenix Scalp',
      entryCatalyst: 'Gap Up on AI Partnership News + Volume Surge',
      smartScore: 8.9,
      currentPrice: 448.75,
      entryTarget: 445.00,
      exitTarget: 465.00,
      stopLoss: 435.00,
      riskReward: 2.0,
      marketCap: '1.1T',
      volume: 45200000,
      lastUpdated: '2025-08-03 09:18:00',
      priority: 'High',
      notes: 'Watching for VWAP reclaim at 445. Quick scalp opportunity.',
      sector: 'Technology'
    },
    {
      id: 4,
      ticker: 'TSLA',
      tradetype: 'Options Core',
      entryCatalyst: 'Q3 Delivery Numbers + FSD Beta Expansion',
      smartScore: 7.1,
      currentPrice: 235.85,
      entryTarget: 230.00,
      exitTarget: 260.00,
      stopLoss: 220.00,
      riskReward: 3.0,
      marketCap: '756B',
      volume: 35600000,
      lastUpdated: '2025-08-03 09:14:00',
      priority: 'Medium',
      notes: 'Volatile but good R/R setup. Watch Musk Twitter activity.',
      sector: 'Automotive'
    },
    {
      id: 5,
      ticker: 'PLTR',
      tradetype: 'Government Intel',
      entryCatalyst: 'Army Contract Award + Government AI Initiative',
      smartScore: 8.4,
      currentPrice: 24.67,
      entryTarget: 23.50,
      exitTarget: 28.00,
      stopLoss: 22.00,
      riskReward: 3.0,
      marketCap: '52B',
      volume: 18750000,
      lastUpdated: '2025-08-03 09:16:00',
      priority: 'Medium',
      notes: 'Government contract catalyst very strong. Patient entry.',
      sector: 'Software'
    },
    {
      id: 6,
      ticker: 'BABA',
      tradetype: 'Phoenix Scalp',
      entryCatalyst: 'China Regulatory Relief + Oversold Bounce',
      smartScore: 7.8,
      currentPrice: 89.45,
      entryTarget: 88.00,
      exitTarget: 95.00,
      stopLoss: 85.00,
      riskReward: 2.3,
      marketCap: '215B',
      volume: 22100000,
      lastUpdated: '2025-08-03 09:11:00',
      priority: 'Medium',
      notes: 'China risk but technical setup is clean. Quick trade only.',
      sector: 'E-commerce'
    }
  ]);

  const [sortBy, setSortBy] = useState('smartScore');
  const [filterPriority, setFilterPriority] = useState('All');
  const [filterStrategy, setFilterStrategy] = useState('All');

  // Helper Functions
  const formatCurrency = (value) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(value);

  const formatNumber = (value) => new Intl.NumberFormat('en-US').format(value);

  const getSmartScoreColor = (score) => {
    if (score >= 8.5) return '#00FF5F';
    if (score >= 7.0) return '#FFB800';
    return '#FF0000';
  };

  const getPriorityColor = (priority) => {
    switch(priority) {
      case 'High': return '#FF0000';
      case 'Medium': return '#FFB800';
      case 'Low': return '#00FF5F';
      default: return '#a0a9c1';
    }
  };

  const getStrategyColor = (strategy) => {
    switch(strategy) {
      case 'Options Core': return '#D4AF37';
      case 'Government Intel': return '#0069B1';
      case 'Phoenix Scalp': return '#5BC0DE';
      default: return '#a0a9c1';
    }
  };

  // Filter and sort watchlist
  const filteredItems = watchlistItems
    .filter(item => filterPriority === 'All' || item.priority === filterPriority)
    .filter(item => filterStrategy === 'All' || item.tradetype === filterStrategy)
    .sort((a, b) => {
      switch(sortBy) {
        case 'smartScore': return b.smartScore - a.smartScore;
        case 'riskReward': return b.riskReward - a.riskReward;
        case 'ticker': return a.ticker.localeCompare(b.ticker);
        default: return 0;
      }
    });

  const handleAddToWatchlist = () => {
    // This would open a modal to add new tickers
    alert('Add to Watchlist functionality - to be implemented');
  };

  return (
    <div style={{
      position: 'relative',
      minHeight: '100vh',
      backgroundColor: '#1a2332',
      color: '#ffffff',
      fontFamily: 'Georgia, serif',
      padding: '24px'
    }}>
      {/* WATERMARK */}
      <div style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        opacity: '0.03',
        pointerEvents: 'none',
        zIndex: '1',
        width: '800px',
        height: '800px'
      }}>
        <img 
          src="/finance-watermark.jpg"
          alt="Financial Trading Watermark"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </div>

      <div style={{ position: 'relative', zIndex: '2', maxWidth: '1600px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '32px'
        }}>
          <div>
            <h1 style={{
              color: '#ffffff',
              fontSize: '32px',
              fontWeight: 'bold',
              margin: '0',
              fontFamily: 'Georgia, serif'
            }}>👀 Trading Watchlist</h1>
            <p style={{
              color: '#a0a9c1',
              fontSize: '16px',
              margin: '8px 0 0 0',
              fontFamily: 'Georgia, serif'
            }}>AI-powered opportunity tracking and trade preparation</p>
          </div>
          <button
            onClick={handleAddToWatchlist}
            style={{
              backgroundColor: '#00FF5F',
              color: '#202A44',
              border: 'none',
              borderRadius: '4px',
              padding: '12px 20px',
              cursor: 'pointer',
              fontFamily: 'Georgia, serif',
              fontWeight: 'bold'
            }}
          >
            + Add Symbol
          </button>
        </div>

        {/* Controls */}
        <div style={{
          display: 'flex',
          gap: '16px',
          marginBottom: '24px',
          alignItems: 'center',
          flexWrap: 'wrap'
        }}>
          <div>
            <label style={{ color: '#a0a9c1', fontSize: '14px', marginRight: '8px', fontFamily: 'Georgia, serif' }}>
              Sort by:
            </label>
            <select 
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              style={{
                backgroundColor: '#202A44',
                color: '#ffffff',
                border: '1px solid #3a4a6b',
                borderRadius: '4px',
                padding: '8px',
                fontFamily: 'Georgia, serif'
              }}
            >
              <option value="smartScore">Smart Score</option>
              <option value="riskReward">Risk/Reward</option>
              <option value="ticker">Ticker A-Z</option>
            </select>
          </div>
          <div>
            <label style={{ color: '#a0a9c1', fontSize: '14px', marginRight: '8px', fontFamily: 'Georgia, serif' }}>
              Priority:
            </label>
            <select 
              value={filterPriority}
              onChange={(e) => setFilterPriority(e.target.value)}
              style={{
                backgroundColor: '#202A44',
                color: '#ffffff',
                border: '1px solid #3a4a6b',
                borderRadius: '4px',
                padding: '8px',
                fontFamily: 'Georgia, serif'
              }}
            >
              <option value="All">All</option>
              <option value="High">High Priority</option>
              <option value="Medium">Medium Priority</option>
              <option value="Low">Low Priority</option>
            </select>
          </div>
          <div>
            <label style={{ color: '#a0a9c1', fontSize: '14px', marginRight: '8px', fontFamily: 'Georgia, serif' }}>
              Strategy:
            </label>
            <select 
              value={filterStrategy}
              onChange={(e) => setFilterStrategy(e.target.value)}
              style={{
                backgroundColor: '#202A44',
                color: '#ffffff',
                border: '1px solid #3a4a6b',
                borderRadius: '4px',
                padding: '8px',
                fontFamily: 'Georgia, serif'
              }}
            >
              <option value="All">All Strategies</option>
              <option value="Options Core">Options Core</option>
              <option value="Government Intel">Government Intel</option>
              <option value="Phoenix Scalp">Phoenix Scalp</option>
            </select>
          </div>
        </div>

        {/* Summary Stats */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: '16px',
          marginBottom: '24px'
        }}>
          <div style={{
            backgroundColor: '#202A44',
            padding: '16px',
            borderRadius: '8px',
            border: '1px solid #3a4a6b',
            textAlign: 'center'
          }}>
            <div style={{ color: '#a0a9c1', fontSize: '12px', marginBottom: '4px', fontFamily: 'Georgia, serif' }}>
              Total Symbols
            </div>
            <div style={{ color: '#ffffff', fontSize: '20px', fontWeight: 'bold', fontFamily: 'Georgia, serif' }}>
              {filteredItems.length}
            </div>
          </div>
          <div style={{
            backgroundColor: '#202A44',
            padding: '16px',
            borderRadius: '8px',
            border: '1px solid #3a4a6b',
            textAlign: 'center'
          }}>
            <div style={{ color: '#a0a9c1', fontSize: '12px', marginBottom: '4px', fontFamily: 'Georgia, serif' }}>
              High Priority
            </div>
            <div style={{ color: '#FF0000', fontSize: '20px', fontWeight: 'bold', fontFamily: 'Georgia, serif' }}>
              {filteredItems.filter(item => item.priority === 'High').length}
            </div>
          </div>
          <div style={{
            backgroundColor: '#202A44',
            padding: '16px',
            borderRadius: '8px',
            border: '1px solid #3a4a6b',
            textAlign: 'center'
          }}>
            <div style={{ color: '#a0a9c1', fontSize: '12px', marginBottom: '4px', fontFamily: 'Georgia, serif' }}>
              Avg Smart Score
            </div>
            <div style={{ color: '#00FF5F', fontSize: '20px', fontWeight: 'bold', fontFamily: 'Georgia, serif' }}>
              {(filteredItems.reduce((sum, item) => sum + item.smartScore, 0) / filteredItems.length).toFixed(1)}
            </div>
          </div>
          <div style={{
            backgroundColor: '#202A44',
            padding: '16px',
            borderRadius: '8px',
            border: '1px solid #3a4a6b',
            textAlign: 'center'
          }}>
            <div style={{ color: '#a0a9c1', fontSize: '12px', marginBottom: '4px', fontFamily: 'Georgia, serif' }}>
              Avg R/R Ratio
            </div>
            <div style={{ color: '#D4AF37', fontSize: '20px', fontWeight: 'bold', fontFamily: 'Georgia, serif' }}>
              {(filteredItems.reduce((sum, item) => sum + item.riskReward, 0) / filteredItems.length).toFixed(1)}
            </div>
          </div>
        </div>

        {/* Watchlist Table */}
        <div style={{
          backgroundColor: '#202A44',
          borderRadius: '8px',
          border: '1px solid #3a4a6b',
          overflow: 'hidden'
        }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '1200px' }}>
              <thead>
                <tr style={{ backgroundColor: '#1a2332', borderBottom: '1px solid #3a4a6b' }}>
                  <th style={{ padding: '16px', textAlign: 'left', color: '#D4AF37', fontFamily: 'Georgia, serif', fontWeight: 'bold' }}>Ticker</th>
                  <th style={{ padding: '16px', textAlign: 'left', color: '#D4AF37', fontFamily: 'Georgia, serif', fontWeight: 'bold' }}>Strategy</th>
                  <th style={{ padding: '16px', textAlign: 'left', color: '#D4AF37', fontFamily: 'Georgia, serif', fontWeight: 'bold' }}>Entry Catalyst</th>
                  <th style={{ padding: '16px', textAlign: 'center', color: '#D4AF37', fontFamily: 'Georgia, serif', fontWeight: 'bold' }}>Smart Score</th>
                  <th style={{ padding: '16px', textAlign: 'right', color: '#D4AF37', fontFamily: 'Georgia, serif', fontWeight: 'bold' }}>Current</th>
                  <th style={{ padding: '16px', textAlign: 'right', color: '#D4AF37', fontFamily: 'Georgia, serif', fontWeight: 'bold' }}>Entry Target</th>
                  <th style={{ padding: '16px', textAlign: 'right', color: '#D4AF37', fontFamily: 'Georgia, serif', fontWeight: 'bold' }}>Exit Target</th>
                  <th style={{ padding: '16px', textAlign: 'center', color: '#D4AF37', fontFamily: 'Georgia, serif', fontWeight: 'bold' }}>R/R</th>
                  <th style={{ padding: '16px', textAlign: 'center', color: '#D4AF37', fontFamily: 'Georgia, serif', fontWeight: 'bold' }}>Priority</th>
                  <th style={{ padding: '16px', textAlign: 'center', color: '#D4AF37', fontFamily: 'Georgia, serif', fontWeight: 'bold' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredItems.map((item) => (
                  <tr key={item.id} style={{ borderBottom: '1px solid #3a4a6b' }}>
                    <td style={{ padding: '16px' }}>
                      <div>
                        <div style={{
                          color: '#ffffff',
                          fontSize: '18px',
                          fontWeight: 'bold',
                          fontFamily: 'Georgia, serif'
                        }}>
                          {item.ticker}
                        </div>
                        <div style={{
                          color: '#a0a9c1',
                          fontSize: '12px',
                          fontFamily: 'Georgia, serif'
                        }}>
                          {item.sector} • {item.marketCap}
                        </div>
                      </div>
                    </td>
                    <td style={{ padding: '16px' }}>
                      <span style={{
                        backgroundColor: getStrategyColor(item.tradetype),
                        color: '#ffffff',
                        padding: '6px 10px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        fontFamily: 'Georgia, serif'
                      }}>
                        {item.tradetype}
                      </span>
                    </td>
                    <td style={{ padding: '16px', maxWidth: '200px' }}>
                      <div style={{
                        color: '#ffffff',
                        fontSize: '14px',
                        fontFamily: 'Georgia, serif',
                        lineHeight: '1.3'
                      }}>
                        {item.entryCatalyst}
                      </div>
                    </td>
                    <td style={{ padding: '16px', textAlign: 'center' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                        <div style={{
                          width: '12px',
                          height: '12px',
                          borderRadius: '50%',
                          backgroundColor: getSmartScoreColor(item.smartScore)
                        }}></div>
                        <span style={{
                          color: '#ffffff',
                          fontSize: '16px',
                          fontWeight: 'bold',
                          fontFamily: 'Georgia, serif'
                        }}>
                          {item.smartScore}
                        </span>
                      </div>
                    </td>
                    <td style={{ padding: '16px', textAlign: 'right' }}>
                      <div>
                        <div style={{
                          color: '#ffffff',
                          fontSize: '16px',
                          fontWeight: 'bold',
                          fontFamily: 'Georgia, serif'
                        }}>
                          {formatCurrency(item.currentPrice)}
                        </div>
                        <div style={{
                          color: '#5BC0DE',
                          fontSize: '12px',
                          fontFamily: 'Georgia, serif'
                        }}>
                          Vol: {formatNumber(item.volume)}
                        </div>
                      </div>
                    </td>
                    <td style={{ padding: '16px', textAlign: 'right' }}>
                      <div style={{
                        color: '#FFB800',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        fontFamily: 'Georgia, serif'
                      }}>
                        {formatCurrency(item.entryTarget)}
                      </div>
                    </td>
                    <td style={{ padding: '16px', textAlign: 'right' }}>
                      <div>
                        <div style={{
                          color: '#00FF5F',
                          fontSize: '16px',
                          fontWeight: 'bold',
                          fontFamily: 'Georgia, serif'
                        }}>
                          {formatCurrency(item.exitTarget)}
                        </div>
                        <div style={{
                          color: '#FF0000',
                          fontSize: '12px',
                          fontFamily: 'Georgia, serif'
                        }}>
                          Stop: {formatCurrency(item.stopLoss)}
                        </div>
                      </div>
                    </td>
                    <td style={{ padding: '16px', textAlign: 'center' }}>
                      <div style={{
                        color: item.riskReward >= 2.5 ? '#00FF5F' : item.riskReward >= 2.0 ? '#FFB800' : '#FF0000',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        fontFamily: 'Georgia, serif'
                      }}>
                        {item.riskReward.toFixed(1)}
                      </div>
                    </td>
                    <td style={{ padding: '16px', textAlign: 'center' }}>
                      <span style={{
                        color: getPriorityColor(item.priority),
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'Georgia, serif'
                      }}>
                        {item.priority}
                      </span>
                    </td>
                    <td style={{ padding: '16px', textAlign: 'center' }}>
                      <button style={{
                        backgroundColor: '#00FF5F',
                        color: '#202A44',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '6px 12px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        fontFamily: 'Georgia, serif'
                      }}>
                        Execute
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Notes Section */}
        <div style={{
          backgroundColor: '#202A44',
          padding: '24px',
          borderRadius: '8px',
          border: '1px solid #3a4a6b',
          marginTop: '24px'
        }}>
          <h3 style={{ color: '#D4AF37', margin: '0 0 16px 0', fontFamily: 'Georgia, serif' }}>
            📝 Market Notes & Strategy Updates
          </h3>
          <div style={{
            backgroundColor: '#1a2332',
            padding: '16px',
            borderRadius: '8px',
            color: '#ffffff',
            fontSize: '14px',
            fontFamily: 'Georgia, serif',
            lineHeight: '1.5'
          }}>
            <strong>Current Market Regime:</strong> Bullish momentum with low VIX (13.4). Focus on growth catalysts.<br/>
            <strong>Strategy Focus:</strong> Phoenix scalps and options core performing well. Government intel timing excellent.<br/>
            <strong>Risk Management:</strong> Keep portfolio heat under 12%. Max 2.5% per trade on elite setups.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Watchlist;